export default {
  title: 'URL SETTINGS',
  items: {
    TermsProvider: {
      label: 'Provider Terms URL',
      type: 'string',
      unit: ''
    },
    FaqsProvider: {
      label: 'Provider FAQs URL',
      type: 'string',
      unit: ''
    },
    ForgotpassProvider: {
      label: 'Provider Forgot Password URL',
      type: 'string',
      unit: ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/url-settings.js